import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Link,
  Typography,
  useTheme,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { getPaymentLink } from '@shared/services/services';

import DoneIcon from '@mui/icons-material/Done';

import PaymentMethod from './PaymentMethod';

import { sxStyled } from './styles';

export default () => {
  const { search } = useLocation();
  const id = search.replace('?id=', '');

  const pageConfiguration = useSelector(store => store.pageConfiguration);

  const theme = useTheme();

  const sxStyle = sxStyled(theme);

  const [cathError, setcathError] = useState({
    error_status: null,
    message: '',
    name: '',
  });
  const [payment, setPayment] = useState({});
  const [aceptCheckout, setAceptCheckout] = useState(false);
  const [isPayment, setIsPayment] = useState(false);

  useEffect(() => {
    if (id) {
      getPatment();
    }
  }, []);

  const getPatment = () => {
    getPaymentLink(id)
      .then(res => {
        if (res?.error_status) {
          setcathError(res);
        }
        if (res) {
          setPayment(res);
        }
      })
      .catch(err => console.error('error', err));
  };

  const handleBack = () => {
    setPayment({});
  };

  return (
    <>
      <Grid
        container
        sx={sxStyle.headerContainer}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <Grid container alignItems="center">
            <Link href="/" align="left">
              <Box
                component="img"
                src={pageConfiguration.site_logos.principal}
                alt="logo"
                sx={sxStyle.logo}
              />
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        alignItems="center"
        direction="column"
        sx={sxStyle.container}
      >
        <Grid item>
          {cathError.error_status === 400 ? (
            <>
              <Typography variant="body1" sx={{ mb: '20px' }}>
                Lo sentimos, no se pudo procesar el cobro.
              </Typography>
              <Typography variant="body1" sx={{ mb: '20px' }}>
                {cathError.message}, por favor, comuníquese nuevamente con su
                agencia de viajes.
              </Typography>
              <Typography variant="body1" sx={{ mb: '20px' }}>
                ¡Muchas gracias!
              </Typography>
            </>
          ) : (
            Object.keys(payment).length !== 0 && (
              <>
                <Grid
                  container
                  alignItems="center"
                  direction="column"
                  style={{ marginBottom: '20px' }}
                >
                  <Grid item>
                    <Typography
                      variant="body1"
                      style={{ marginBottom: '20px' }}
                    >
                      ¡Muchas Gracias por elegirnos!
                    </Typography>
                    <Typography variant="body1">Concepto de pago</Typography>
                    <Typography variant="body1">
                      Total a financiar: <strong>{payment.amount}</strong>{' '}
                    </Typography>
                    <Typography variant="body1">
                      Pasajero de Referencia:{' '}
                      <strong>{payment.ref_passenger}</strong>
                    </Typography>
                    <Typography variant="body1">
                      File: <strong>{payment.file_number}</strong>
                    </Typography>
                    <Typography variant="body1">
                      Email: <strong>{payment.client_email}</strong>
                    </Typography>
                    <Typography variant="body1">
                      Número de WhatsApp:{' '}
                      <strong>{payment.phone_passenger}</strong>
                    </Typography>
                  </Grid>
                </Grid>
                {!isPayment ? (
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignContent: 'flex-start',
                    }}
                  >
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '16px' }}>
                        <Typography
                          style={{
                            cursor: 'pointer',
                            marginBottom: '10px',
                          }}
                          onClick={() => setAceptCheckout(!aceptCheckout)}
                        >
                          <FormControlLabel
                            style={{ margin: 0 }}
                            control={
                              <Checkbox
                                checkedIcon={
                                  <DoneIcon
                                    style={{ color: 'rgb(170, 230, 230)' }}
                                  />
                                }
                                checked={aceptCheckout}
                              />
                            }
                          ></FormControlLabel>
                          Los datos se corresponden con mi compra
                        </Typography>
                      </div>
                      <Button
                        disabled={!aceptCheckout}
                        sx={sxStyle.btn}
                        onClick={() => setIsPayment(true)}
                      >
                        CONTINUAR PAGO
                      </Button>
                    </div>
                  </Box>
                ) : (
                  <PaymentMethod
                    idLink={id}
                    payment={payment}
                    handleBack={handleBack}
                  />
                )}
              </>
            )
          )}
        </Grid>
      </Grid>
    </>
  );
};
